import React, { useEffect, useState } from 'react';
import styles from 'routes/vendorRe/pages/VendorStats.module.css';
import LineChart from 'routes/vendorRe/components/LineChart';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import { requester } from 'App';
import Flex from 'layouts/flex/Flex';
import * as XLSX from 'xlsx';
// html2canvas와 jsPDF 임포트
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const SettlementStatus = () => {
    const [isMounted, setMounted] = useState(false);
    const [totalWeekEachAmount, setTotalWeekEachAmount] = useState();
    const [salesOverview, setSalesOverview] = useState();
    const [isExporting, setIsExporting] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            requester.getWeeklySalesStatus((result) => {
                setTotalWeekEachAmount(result.data);
                console.log(result.data);
            });
            requester.getVendorSalesOverview((result) => {
                setSalesOverview(result.data);
                console.log(result.data);
            });
        }
    }, [isMounted]);

    // 모의 데이터 생성 함수
    const generateMockSalesData = () => {
        const data = [];
        const startDate = new Date(2023, 0, 1); // 2023년 1월 1일

        // 1년치 주간 데이터 생성 (52주)
        for (let i = 0; i < 52; i++) {
            const currentDate = new Date(startDate);
            currentDate.setDate(startDate.getDate() + (i * 7));

            const weekStart = new Date(currentDate);
            const weekEnd = new Date(currentDate);
            weekEnd.setDate(weekStart.getDate() + 6);

            // 포맷팅 함수
            const formatDate = (date) => {
                return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
            };

            // 주간 매출 데이터 생성
            const weekData = {
                weekNumber: i + 1,
                weekStart: formatDate(weekStart),
                weekEnd: formatDate(weekEnd),
                totalSales: Math.floor(Math.random() * 10000000) + 500000, // 50만원 ~ 1050만원
                orderCount: Math.floor(Math.random() * 100) + 20, // 20 ~ 120건
                avgOrderValue: 0, // 나중에 계산
                productsSold: Math.floor(Math.random() * 150) + 30, // 30 ~ 180개
            };

            // 평균 주문 금액 계산
            weekData.avgOrderValue = Math.round(weekData.totalSales / weekData.orderCount);

            data.push(weekData);
        }

        return data;
    };

    // Excel 파일로 내보내기
    const exportToExcel = (data, fileName = '판매내역.xlsx') => {
        // 워크북 생성
        const wb = XLSX.utils.book_new();

        // 워크시트 생성
        const ws = XLSX.utils.json_to_sheet(data);

        // 컬럼 너비 설정
        const colWidths = [
            { wch: 10 }, // 주차
            { wch: 12 }, // 시작일
            { wch: 12 }, // 종료일
            { wch: 15 }, // 총 매출
            { wch: 12 }, // 주문 건수
            { wch: 15 }, // 평균 주문액
            { wch: 12 }, // 판매 상품수
        ];

        ws['!cols'] = colWidths;

        // 워크북에 워크시트 추가
        XLSX.utils.book_append_sheet(wb, ws, '판매내역');

        // 파일로 내보내기
        XLSX.writeFile(wb, fileName);

        return true;
    };

    // PDF 파일로 내보내기 - html2canvas + jsPDF 방식
    const exportToPDF = (data, fileName = '판매내역.pdf') => {
        try {
            setIsExporting(true);

            // 임시 테이블 컨테이너 생성
            const tempDiv = document.createElement('div');
            tempDiv.id = 'temp-table-container';
            tempDiv.style.width = '800px'; // 고정 너비 설정
            tempDiv.style.padding = '20px';
            tempDiv.style.backgroundColor = 'white';
            tempDiv.style.position = 'absolute'; // fixed에서 absolute로 변경
            tempDiv.style.top = '0';
            tempDiv.style.left = '0';
            tempDiv.style.zIndex = '9999'; // 음수에서 양수로 변경
            // tempDiv.style.visibility = 'hidden'; // 숨김 처리 제거
            tempDiv.style.overflow = 'auto'; // 오버플로우 처리 추가

            // 테이블 HTML 생성
            tempDiv.innerHTML = `
                <div style="font-family: Arial, sans-serif; width: 100%;">
                    <h2 style="text-align: center; margin-bottom: 10px; color: #000;">판매내역 보고서</h2>
                    <p style="text-align: center; margin-bottom: 20px; color: #000;">생성일: ${new Date().toLocaleDateString()}</p>
                    <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
                        <thead>
                            <tr style="background-color: #444; color: white;">
                                <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">주차</th>
                                <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">시작일</th>
                                <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">종료일</th>
                                <th style="padding: 8px; text-align: right; border: 1px solid #ddd;">총 매출(원)</th>
                                <th style="padding: 8px; text-align: right; border: 1px solid #ddd;">주문 건수</th>
                                <th style="padding: 8px; text-align: right; border: 1px solid #ddd;">평균 주문액(원)</th>
                                <th style="padding: 8px; text-align: right; border: 1px solid #ddd;">판매 상품수</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${data.slice(0, 50).map((item, index) => `
                                <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : 'white'};">
                                    <td style="padding: 8px; text-align: left; border: 1px solid #ddd; color: #000;">${item.weekNumber}</td>
                                    <td style="padding: 8px; text-align: left; border: 1px solid #ddd; color: #000;">${item.weekStart}</td>
                                    <td style="padding: 8px; text-align: left; border: 1px solid #ddd; color: #000;">${item.weekEnd}</td>
                                    <td style="padding: 8px; text-align: right; border: 1px solid #ddd; color: #000;">${item.totalSales.toLocaleString()}</td>
                                    <td style="padding: 8px; text-align: right; border: 1px solid #ddd; color: #000;">${item.orderCount}</td>
                                    <td style="padding: 8px; text-align: right; border: 1px solid #ddd; color: #000;">${item.avgOrderValue.toLocaleString()}</td>
                                    <td style="padding: 8px; text-align: right; border: 1px solid #ddd; color: #000;">${item.productsSold}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </div>
            `;

            // 임시 요소를 DOM에 추가
            document.body.appendChild(tempDiv);

            // 충분한 지연 시간 후 HTML을 캔버스로 변환 (렌더링 시간 확보)
            setTimeout(() => {
                // 원본 너비와 높이 저장
                const originalWidth = tempDiv.style.width;
                const originalHeight = tempDiv.style.height;

                // HTML2Canvas 옵션
                html2canvas(tempDiv, {
                    scale: 2, // 고해상도
                    useCORS: true,
                    allowTaint: true, // 크로스 도메인 이미지 허용
                    backgroundColor: '#FFFFFF', // 배경색 지정
                    logging: true, // 디버깅용 로깅 활성화
                    windowWidth: 800, // 창 너비 설정
                    windowHeight: 600, // 창 높이 설정
                    x: 0, // x 좌표 설정
                    y: 0, // y 좌표 설정
                    width: parseInt(originalWidth), // 너비 설정
                    height: parseInt(originalHeight || window.getComputedStyle(tempDiv).height) // 높이 설정
                }).then(canvas => {
                    console.log('Canvas created:', canvas.width, 'x', canvas.height);

                    // 캔버스 데이터를 이미지로 변환
                    const imgData = canvas.toDataURL('image/png');
                    console.log('Image data created');

                    // jsPDF 인스턴스 생성 (가로 방향)
                    const pdf = new jsPDF('landscape', 'mm', 'a4');

                    // A4 페이지의 가로 폭 (가로 방향)
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = pdf.internal.pageSize.getHeight();

                    // 캔버스 비율 계산 (이미지 비율 유지)
                    const imgWidth = canvas.width;
                    const imgHeight = canvas.height;
                    const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

                    // 중앙 정렬을 위한 위치 계산
                    const imgX = (pdfWidth - imgWidth * ratio) / 2;

                    // 이미지를 PDF에 추가
                    pdf.addImage(imgData, 'PNG', imgX, 10, imgWidth * ratio, imgHeight * ratio);
                    console.log('Image added to PDF');

                    // PDF 파일 저장
                    pdf.save(fileName);
                    console.log('PDF saved');

                    // 임시 요소 제거
                    document.body.removeChild(tempDiv);
                    setIsExporting(false);
                }).catch(err => {
                    console.error("html2canvas 오류:", err);
                    document.body.removeChild(tempDiv);
                    setIsExporting(false);
                    alert("PDF 생성 중 오류가 발생했습니다.");
                });
            }, 500); // 지연 시간 늘림

            return true;
        } catch (error) {
            console.error("PDF 내보내기 오류:", error);
            if (document.getElementById('temp-table-container')) {
                document.body.removeChild(document.getElementById('temp-table-container'));
            }
            setIsExporting(false);
            alert("PDF 내보내기 중 오류가 발생했습니다.");
            return false;
        }
    };

    // 간단한 대체 방법: window.print() 사용
    const exportToPDFWithPrint = (data, fileName = '판매내역.pdf') => {
        try {
            // 현재 페이지의 내용을 보존
            const originalContent = document.body.innerHTML;

            // 인쇄용 콘텐츠로 교체
            document.body.innerHTML = `
                <div style="padding: 20px; font-family: Arial, sans-serif;">
                    <h2 style="text-align: center;">판매내역 보고서</h2>
                    <p style="text-align: center;">생성일: ${new Date().toLocaleDateString()}</p>
                    <table border="1" cellpadding="5" cellspacing="0" style="width: 100%; border-collapse: collapse; margin-top: 20px;">
                        <thead>
                            <tr style="background-color: #444; color: white;">
                                <th>주차</th>
                                <th>시작일</th>
                                <th>종료일</th>
                                <th>총 매출(원)</th>
                                <th>주문 건수</th>
                                <th>평균 주문액(원)</th>
                                <th>판매 상품수</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${data.map((item, index) => `
                                <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : 'white'};">
                                    <td>${item.weekNumber}</td>
                                    <td>${item.weekStart}</td>
                                    <td>${item.weekEnd}</td>
                                    <td style="text-align: right;">${item.totalSales.toLocaleString()}</td>
                                    <td style="text-align: right;">${item.orderCount}</td>
                                    <td style="text-align: right;">${item.avgOrderValue.toLocaleString()}</td>
                                    <td style="text-align: right;">${item.productsSold}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </div>
            `;

            // 인쇄 다이얼로그 표시
            window.print();

            // 원래 콘텐츠로 복원
            document.body.innerHTML = originalContent;

            return true;
        } catch (error) {
            console.error("인쇄 오류:", error);
            alert("PDF 내보내기 중 오류가 발생했습니다.");
            return false;
        }
    };

    const handleExport = (type = 'excel') => {
        // 이미 내보내기 중이면 중복 실행 방지
        if (isExporting) {
            return;
        }

        // 테스트를 위한 모의 데이터 생성
        const mockData = generateMockSalesData();

        if (type === 'excel') {
            exportToExcel(mockData);
        } else if (type === 'pdf') {
            // 시도 1: html2canvas 방식
            try {
                exportToPDF(mockData);
            } catch (error) {
                console.error("PDF 내보내기 실패, 대체 방법 시도:", error);
                // 시도 2: 브라우저 인쇄 방식
                exportToPDFWithPrint(mockData);
            }
        }
    };


    return (
        <FlexChild backgroundColor="white" padding="1em" borderRadius="1em">
            <VerticalFlex>
                <FlexChild alignItems={"flex-start"} padding={"0 0 1em"}>
                    <HorizontalFlex>
                        <FlexChild>
                            <P weight={700} size={"max(1.3vw, 25px)"}>매출현황</P>
                        </FlexChild>
                        <FlexChild justifyContent={"flex-end"}>
                            <HorizontalFlex>
                                <FlexChild marginRight="0.5em">
                                    <div
                                        onClick={() => handleExport('excel')}
                                        style={{
                                            width: "fit-content",
                                            padding: "0.5em 1em",
                                            borderRadius: "1em",
                                            backgroundColor: "#F2F2F2",
                                            fontSize: "max(1vw, 15px)",
                                            cursor: isExporting ? "not-allowed" : "pointer",
                                            opacity: isExporting ? 0.6 : 1
                                        }}
                                    >
                                        <P>{isExporting ? "내보내는 중..." : "Excel 내보내기"}</P>
                                    </div>
                                </FlexChild>
                                <FlexChild>
                                    <div
                                        onClick={() => handleExport('pdf')}
                                        style={{
                                            width: "fit-content",
                                            padding: "0.5em 1em",
                                            borderRadius: "1em",
                                            backgroundColor: "#F2F2F2",
                                            fontSize: "max(1vw, 15px)",
                                            cursor: isExporting ? "not-allowed" : "pointer",
                                            opacity: isExporting ? 0.6 : 1
                                        }}
                                    >
                                        <P>{isExporting ? "내보내는 중..." : "PDF 내보내기"}</P>
                                    </div>
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                    {/* 라인 그래프 영역 */}
                    <LineChart totalWeekEachAmount={totalWeekEachAmount} />
                </FlexChild>
                <FlexChild>
                    <div className={styles.borderBottom}>
                        <HorizontalFlex padding={"1em 0"}>
                            <FlexChild>
                                <P size={"max(1vw, 20px)"}>오늘 매출</P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-end"}>
                                <P weight={700} size={"max(1.3vw, 25px)"}>{salesOverview ? salesOverview.todayTotalPrice.toLocaleString() : 0}</P>
                            </FlexChild>
                        </HorizontalFlex>
                    </div>
                    <div className={styles.borderBottom}>
                        <HorizontalFlex padding={"1em 0"}>
                            <FlexChild>
                                <P size={"max(1vw, 20px)"}>이번주 매출</P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-end"}>
                                <P weight={700} size={"max(1.3vw, 25px)"}>{salesOverview ? salesOverview.thisWeekTotalPrice.toLocaleString() : 0}</P>
                            </FlexChild>
                        </HorizontalFlex>
                    </div>
                    <div className={styles.borderBottom}>
                        <HorizontalFlex padding={"1em 0"}>
                            <FlexChild>
                                <P size={"max(1vw, 20px)"}>이번달 매출</P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-end"}>
                                <P weight={700} size={"max(1.3vw, 25px)"}>{salesOverview ? salesOverview.thisMonthTotalPrice.toLocaleString() : 0}</P>
                            </FlexChild>
                        </HorizontalFlex>
                    </div>
                    <HorizontalFlex padding={"1em 0"}>
                        <FlexChild>
                            <P size={"max(1vw, 20px)"}>올해 매출</P>
                        </FlexChild>
                        <FlexChild justifyContent={"flex-end"}>
                            <P weight={700} size={"max(1.3vw, 25px)"}>{salesOverview ? salesOverview.thisYearTotalPrice.toLocaleString() : 0}</P>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
            </VerticalFlex>
        </FlexChild>
    );
};

export default SettlementStatus;